import { useEffect } from 'react';
import { Link } from 'react-router';

import { useDerbyStore } from '@/entities/derby';
import { ROUTES } from '@/shared/config';
import { RADIUS, StaticSquircle } from '@/shared/ui';

import styles from './HeroBanner.module.scss';

/** Промо-карточка на главном экране. По макету Figma (узел 438:48165). */
export function HeroBanner() {
  const derby = useDerbyStore((state) => state.derby);
  const loadDerby = useDerbyStore((state) => state.load);

  useEffect(() => {
    void loadDerby();
  }, [loadDerby]);

  // Пока Дерби открыто, кнопка зовёт играть — и пройденное тоже не
  // в счёт (правка 14.09.2026). Когда открыто, решает сервер:
  // `/derby/current` отдаёт Дерби только внутри его окна, поэтому своих
  // часов у клиента нет. Ведёт туда же, куда «Играть» в приглашении, —
  // в «Прогнозы» к баннеру
  const derbyIsOn = derby !== null;

  return (
    <StaticSquircle
      width={390}
      height={524}
      cornerRadius={RADIUS.xl}
      className={styles.root}
    >
      <div className={styles.wedgeBox}>
        <img
          className={styles.wedge}
          src="/images/hero/wedge.svg"
          alt=""
          aria-hidden
        />
      </div>
      <img
        className={styles.ball}
        src="/images/hero/bb-ball.webp"
        alt=""
        aria-hidden
      />

      <h1 className={styles.headline} data-testid="hero-headline">
        BetBoom здесь играют
      </h1>

      <p className={styles.text}>
        Делай прогнозы, получай очки и забирай призы
      </p>

      <StaticSquircle asChild width={358} height={104} cornerRadius={RADIUS.xl}>
        <Link className={styles.cta} to={ROUTES.matches} data-testid="hero-cta">
          {derbyIsOn ? 'Играть' : 'Сделать прогноз'}
        </Link>
      </StaticSquircle>
    </StaticSquircle>
  );
}
